module.exports = __webpack_public_path__ + "img/up.4bd12365.svg";